import { cleanupFcmOnLogout } from '@/libs/firebase/fcmCleanup';
import { logoutThunk } from '../slices/auth';

export const logout = async () => {
    const { store } = await import('..');
    const { persistor } = await import('../persistor/redux-persistor');

    await cleanupFcmOnLogout({
        unSubscribeTopic: async token => {
            const { notificationService } = await import('@/services/rest');

            await notificationService()
                .unSubscribeTopic({ token })
                .catch(() => {});
        },
    });

    await store.dispatch(logoutThunk());
    await persistor.purge();
};
